/**
 * Amazon parent → child shelf index for the Framework picker.
 * Paths use the content-pass separator " › ".
 */

export function splitAmazonPath(path) {
  return String(path || '')
    .split('›')
    .map((part) => part.trim())
    .filter(Boolean);
}

/**
 * One level of the shelf tree.
 * children: next path segment, with how many packs sit at or under it.
 * packs: packs whose full path is exactly the current trail.
 * broad: library packs with no Amazon path (the five wide shapes).
 */
export function shelfLevel(items, trail = []) {
  const childGroups = new Map();
  const packs = [];
  const broad = [];
  (items || []).forEach((item) => {
    const parts = splitAmazonPath(item?.amazon_parent_path);
    if (!parts.length) {
      broad.push(item);
      return;
    }
    const onTrail = trail.every((segment, index) => parts[index] === segment);
    if (!onTrail) return;
    if (parts.length === trail.length) {
      packs.push(item);
      return;
    }
    const next = parts[trail.length];
    if (!childGroups.has(next)) childGroups.set(next, []);
    childGroups.get(next).push(item);
  });
  return {
    children: [...childGroups.entries()].map(([label, group]) => ({
      label,
      count: group.length,
    })),
    packs,
    broad,
  };
}

/** Parent paths that hold more than one pack. */
export function sharedShelfPaths(items) {
  const counts = new Map();
  (items || []).forEach((item) => {
    const path = item?.amazon_parent_path;
    if (!path) return;
    counts.set(path, (counts.get(path) || 0) + 1);
  });
  return new Set(
    [...counts.entries()].filter(([, count]) => count > 1).map(([path]) => path),
  );
}
